import { type TransformationContext } from "~/features/configurator/common/translationUtils";
import {
  AL_AND_AR_ADD_DESCRIPTION,
  ALAR_NOT_RECOMMENDED_WARNING,
  ALAR_RECOMMENDED_LABEL,
  CONFIGURATOR_NAME_KEY,
  CONTACT_STC_ADD_DESCRIPTION,
  resolveExternalAdvancedTranslation,
  resolveInternalAdvancedTranslation,
} from "~/features/configurator/common/advancedTranslationUtils";
import { type LinearConfigurationDTO } from "~/features/configurator/Linear/dtos";
import { ConfiguratorType } from "~/domains/configurator/types/ConfiguratorType";
import type { TranslationModel } from "~/common/types/TranslationModel";

export const RESET_STANDARD_AND_LENGTH = "RESET_STANDARD_AND_LENGTH";

export const SYSTEM_ADVANCED_TRANSLATION_KEYS = [
  AL_AND_AR_ADD_DESCRIPTION,
  CONTACT_STC_ADD_DESCRIPTION,
  ALAR_NOT_RECOMMENDED_WARNING,
  ALAR_RECOMMENDED_LABEL,
];

export function buildAdvancedTranslationsForUnit(
  context: TransformationContext,
  dto: LinearConfigurationDTO | LinearConfigurationDTO,
) {
  const translations = {} as Dict<TranslationModel>;

  SYSTEM_ADVANCED_TRANSLATION_KEYS.forEach((key) =>
    resolveExternalAdvancedTranslation(
      translations,
      {
        ...context,
        configuratorType: ConfiguratorType.Rail, // Fake the type, so we properly resolve this
      },
      key,
    ),
  );

  resolveInternalAdvancedTranslation(translations, CONFIGURATOR_NAME_KEY, "page.registerForFree.banner.lc");

  return translations;
}
